import React from "react";

/*
 * Abstract dot-matrix India — editorial representation (not a survey map).
 * Gold markers indicate market presence. Optionally interactive.
 */
const GRID = [
  "        ###",
  "       #####",
  "      ######",
  "     #######",
  "    ########",
  "   ##########",
  "  ############",
  "  #############",
  " ##############  ##",
  " ################ ####",
  "##################  ###",
  " ################   ##",
  "##  ##############",
  "##   #############",
  "      ###########",
  "      ##########",
  "       #########",
  "       ########",
  "        #######",
  "        ######",
  "        #####",
  "         ####",
  "         ###",
  "          ##",
  "          #",
];

export const INDIA_MARKERS = [
  { name: "Himachal Pradesh", col: 9.6, row: 3.2 },
  { name: "Punjab", col: 6.8, row: 4.2 },
  { name: "Chandigarh", col: 8.4, row: 4.7 },
  { name: "Haryana", col: 7.4, row: 5.9 },
  { name: "Delhi NCR", col: 9.3, row: 6.3 },
  { name: "Uttar Pradesh", col: 12, row: 7.6 },
  { name: "Madhya Pradesh", col: 9, row: 11 },
  { name: "Maharashtra", col: 6.2, row: 14 },
  { name: "Andhra Pradesh", col: 10.8, row: 15.8 },
  { name: "Goa", col: 5.8, row: 16.8 },
  { name: "Karnataka", col: 7.9, row: 18 },
  { name: "Tamil Nadu", col: 9.3, row: 20.6 },
];

const S = 15; // grid spacing
const OX = 24;
const OY = 24;

export const IndiaDotMap = ({ interactive = false, activeName = null, onSelect, className = "" }) => {
  return (
    <svg
      viewBox="0 0 400 420"
      className={`w-full h-auto ${className}`}
      role={interactive ? "group" : "img"}
      aria-label="Abstract map of HCC market presence across Indian states"
    >
      {GRID.map((row, r) =>
        row.split("").map((ch, c) =>
          ch === "#" ? (
            <circle
              key={`${r}-${c}`}
              cx={OX + c * S}
              cy={OY + r * S}
              r="3"
              className="fill-[#6F7478]"
              opacity="0.32"
            />
          ) : null
        )
      )}
      {INDIA_MARKERS.map((m) => {
        const x = OX + m.col * S;
        const y = OY + m.row * S;
        const active = activeName === m.name;
        return (
          <g
            key={m.name}
            data-testid={`india-marker-${m.name.toLowerCase().replace(/\s+/g, "-")}`}
            onClick={interactive ? () => onSelect && onSelect(m.name) : undefined}
            style={interactive ? { cursor: "pointer" } : undefined}
            role={interactive ? "button" : undefined}
            aria-label={m.name}
          >
            {interactive && <circle cx={x} cy={y} r="13" fill="transparent" />}
            <circle cx={x} cy={y} r={active ? 6 : 4} className="fill-[#C7A45D] transition-all duration-300" />
            <circle cx={x} cy={y} r={active ? 11 : 8} fill="none" stroke="#C7A45D" strokeOpacity={active ? 0.7 : 0.3} strokeWidth="0.8" className="hcc-pulse" />
            {active && (
              <text
                x={x + 14}
                y={y + 4}
                className="fill-[#F7F1E7]"
                style={{ font: "600 11px Manrope, sans-serif", letterSpacing: "0.14em", textTransform: "uppercase" }}
              >
                {m.name}
              </text>
            )}
          </g>
        );
      })}
    </svg>
  );
};
